// Configuration du site www.mis-gestiones-luz.es : identité, horaires, textes, Google.
// Numéros : config/phoneConfig.js · Marques et URL d'annonces : config/providersData.js
// Textes en espagnol : guillemets doubles uniquement (une apostrophe dans une chaîne entre apostrophes casse le build).
import { PHONES } from "./phoneConfig";
import { PROVIDERS, HOME_ALIASES } from "./providersData";

export const SITE = {
  key: "energia",
  domain: "https://www.mis-gestiones-luz.es",
  brandName: "Mis Gestiones Luz",
  siteLabel: "mis-gestiones-luz.es",
  logoTop: "mis gestiones",
  logoBottom: "luz.es",
  themeColor: "#1F3C88",

  phones: PHONES,

  // Mêmes horaires partout (pages, pied de page, FAQ, extensions et annonces Call Only).
  hours: "de lunes a viernes de 9:00 a 21:00 y los sábados de 9:00 a 18:00",

  company: {
    name: "NOMA CREATIVA S.L.",
    form: "sociedad de responsabilidad limitada unipersonal, con un capital social de 3.000 €",
    cif: "B75294942",
    register: "inscrita en el Registro Mercantil de Barcelona, hoja B-660273",
    address: "Ronda General Mitre 126, 6.ª planta, 08021 Barcelona (España)",
    phone: "+34 930 52 37 15", // numéro administratif : texte simple, jamais en lien tel:
    email: "contact@mis-gestiones-luz.es",
    privacyEmail: "contact@mis-gestiones-luz.es",
  },
  emailResponse: "en un plazo de 72 horas laborables",

  vertical: {
    product: "de luz y gas",
    partner: "un socio especializado en la contratación de suministros de luz y gas",
    notA: "ni una comercializadora de energía ni una distribuidora eléctrica",
    eyebrow: "Comparador de ofertas de luz y gas",
    homeTitle: "Compara las ofertas de luz y gas",
    homeSub:
      "Un asesor compara por teléfono las ofertas de nuestras comercializadoras asociadas según tu consumo y te ayuda a contratar la que elijas.",
    bullets: [
      "Comparación gratuita de las ofertas de nuestros socios",
      "Cambio de comercializadora sin cortes de suministro",
      "Alta de luz y gas al mudarte",
    ],
    savingsTitle: "Reduce tu factura de la luz",
    savingsText:
      "Una tarifa más adecuada a tu vivienda y a tu consumo puede bajar tu factura. El cambio de comercializadora no requiere obras ni cortes de suministro.",
    seoTitle: "Comparar ofertas de luz y gas",
    seoDescription:
      "Mis Gestiones Luz compara por teléfono las ofertas de luz y gas de sus comercializadoras asociadas. Servicio de comparación gratuito.",
    existingContract: "factura, baja, reclamación o avería",
    supplierWord: "comercializadora",
    ourSuppliers: "nuestras comercializadoras asociadas",
    supplierSelection: "una selección de comercializadoras asociadas",
    byTheSuppliers: "por las comercializadoras",
    areYouQuestion: "¿Sois una comercializadora de luz?",
  },

  // Encadré « avería » (énergie uniquement) : texte simple, sans numéro de marque.
  emergency: {
    title: "¿Avería, corte de luz u olor a gas?",
    intro: "No gestionamos averías ni urgencias. Contacta directamente:",
    items: [
      {
        label: "Avería o corte de luz",
        value: "la distribuidora eléctrica de tu zona; su teléfono de averías figura en tu factura de la luz",
      },
      {
        label: "Olor a gas",
        value: "el teléfono de urgencias de tu distribuidora de gas, que figura en tu factura, o el 112",
      },
    ],
  },

  // Couleurs de l'accueil et des pages sans couleur de marque.
  defaultTheme: { primary: "#1F3C88", secondary: "#2F80ED" },

  providers: PROVIDERS,
  homeAliases: HOME_ALIASES,

  // Identifiant Google Ads (AW-XXXXXXX) à renseigner si une balise doit être chargée après consentement.
  googleTagId: "",
};
